<template>
  <div class="container">
    <span v-if="isLoading">Creating game, please wait...</span>

    <div v-else
       class="content"
    >
      <label class="item">How many players?</label>
      <select class="item" v-model="numberOfPlayers">
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
      </select>

      <o-button @click="createGame" class="item">
        Create Game
      </o-button>
    </div>

    <the-rules />
    <buy-me-a-coffee />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { NS_GAME_STATE } from "../store/constants";
import { ROUTE_GAME } from '@/router/constants';
import OButton from "@/components/OButton";
import BuyMeACoffee from "@/components/BuyMeACoffee";
import TheRules from "@/components/TheRules";

export default {
  name: 'NewGame',

  components: {
    TheRules,
    BuyMeACoffee,
    OButton
  },

  data() {
    return {
      numberOfPlayers: 3,
      isLoading: false,
    }
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'gameId',
    ]),
  },

  methods: {
    ...mapActions(NS_GAME_STATE, [
      'createNewGame',
    ]),

    async createGame() {
      this.isLoading = true;
      await this.createNewGame(this.numberOfPlayers);
      this.isLoading = false;

      this.$router.push({
        name: ROUTE_GAME,
        params: {
          gameId: this.gameId
        }
      });
    }
  },
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 300px;
  margin: auto;
}

.content {
  display: flex;
  flex-direction: column;
}

.item {
  margin-bottom: 15px;
}
</style>
